import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ImageGallery } from '../components/ImageGallery';

export default function SearchPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="noise-overlay" />
      <Navbar />

      <main className="flex-1">
        <section className="container mx-auto px-6 md:px-12 lg:px-24 py-12 md:py-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-10"
          >
            <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight mb-3">
              Search
            </h1>
            <p className="text-base text-muted-foreground max-w-xl mx-auto">
              Filter by category, tags, or keywords to find the collection you're after.
            </p>
          </motion.div>

          <ImageGallery requireFilters />
        </section>
      </main>

      <Footer />
    </div>
  );
}
